export default "__VITE_ASSET__Dug7gFDD__"